import React from "react";
import { Table, TableBody, TableContainer, TableHead, TableRow, Paper, Typography } from "@material-ui/core";
import { AiFillFilePdf } from "react-icons/ai";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";

const rows = [
  { slNo: 1, name: "Amit Singh Thakur", email: "N/A", mobile: "9736300042", RegdNo: "RE0003/2016", Regdate: "29-Nov-2016" },
  { slNo: 2, name: "Anil Kapoor", email: "N/A", mobile: "", RegdNo: "R.C. No. 01/2015", Regdate: "22-JAN-2015" },
  { slNo: 3, name: "Bakhtawar Singh", email: "N/A", mobile: "9816021084", RegdNo: "RE0005/2017", Regdate: "04-Jul-2017" },
  { slNo: 4, name: "Dhruv Garg, Prop. Assets Pro", email: "N/A", mobile: "9805992111", RegdNo: "RE0004/2017", Regdate: "22-Feb-2017" },
  { slNo: 5, name: "Kcr Estates Private Limited", email: "N/A", mobile: "9816072072", RegdNo: "RE0006/2017", Regdate: "04-Jul-2017" },
  { slNo: 6, name: "M/s Pinewood Aggregators Pvt. Ltd.", email: "N/A", mobile: "", RegdNo: "R.C. No. 03/2015", Regdate: "22-Jan-2015" },
  {
    slNo: 7,
    name: "M/s Sandalee Real Estates Promoters And Developers Pvt. Ltd.",
    email: "N/A",
    mobile: "",
    RegdNo: "R.C. No. 02/2015",
    Regdate: "22-Jan-2015",
  },
  { slNo: 8, name: "M/s Shandil Estates", email: "N/A", mobile: "", RegdNo: "R.C. No. 09/2015", Regdate: "25-Jun-2015" },
  { slNo: 9, name: "Madhu Bala", email: "N/A", mobile: "9418019872", RegdNo: "RE0002/2016", Regdate: "10-Aug-2016" },
  { slNo: 10, name: "Sh. Ajay Kumar", email: "N/A", mobile: "", RegdNo: "R.C. No.05/2015 ", Regdate: "28-Jan-2015" },
  { slNo: 11, name: "Sh. Atul Rajput", email: "N/A", mobile: "", RegdNo: "R.C. No. 07/2015", Regdate: "16-Feb-2015" },
  { slNo: 12, name: "Sh. Med Ram Sharma", email: "N/A", mobile: "", RegdNo: "R.C. No. 08/2015", Regdate: "05-Mar-2015" },
  { slNo: 13, name: "Sh. Onkar Chand Rana", email: "N/A", mobile: "", RegdNo: "R.C. No. 10/2015", Regdate: "07-Aug-2015" },
  {
    slNo: 14,
    name: "Swastik Estates Through Sole Proprietor Smt. Reeti Shandil",
    email: "N/A",
    mobile: "9418434540",
    RegdNo: "RE0001/2016",
    Regdate: "09-Feb-2016",
  },
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const handlePdfDownload = (pdfUrl) => {
  window.open(pdfUrl);
};

const RegisteredAgent = () => {
  return (
    <React.Fragment>
      <TableContainer component={Paper}>
        <Typography variant="h6" style={{ margin: "20px" }}>
          Registered Estate Agent
        </Typography>
        <Table aria-label="Sample Table" style={{ width: "90%", margin: "30px" }}>
          <TableHead>
            <StyledTableRow style={{ background: "#1F4A7C", height: "20px", color: "white" }}>
              <StyledTableCell style={{ color: "white", border: "1px solid #ffff" }}>SL. No</StyledTableCell>
              <StyledTableCell style={{ color: "white", border: "1px solid #ffff" }}>Name</StyledTableCell>
              <StyledTableCell style={{ color: "white", border: "1px solid #ffff" }}>Email</StyledTableCell>
              <StyledTableCell style={{ color: "white", border: "1px solid #ffff" }}>Reg.NO.</StyledTableCell>
              <StyledTableCell style={{ color: "white", border: "1px solid #ffff" }}>Reg.Date.</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <StyledTableRow key={row.slNo}>
                <StyledTableCell component="th" scope="row">
                  {row.slNo}
                </StyledTableCell>
                <StyledTableCell>{row.name}</StyledTableCell>
                <StyledTableCell>{row.email}</StyledTableCell>
                <StyledTableCell>{row.RegdNo}</StyledTableCell>
                <StyledTableCell>{row.Regdate}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
};

export default RegisteredAgent;
